<ng-container *ngIf="isAdmin; else nonAdminView">
  <app-admin-support-ticket-system></app-admin-support-ticket-system>
</ng-container>

<ng-template #nonAdminView>
  <app-buyer-support-ticket-system *ngIf="showBuyerView; else supplierView"></app-buyer-support-ticket-system>

  <ng-template #supplierView>
    <app-supplier-support-ticket-system></app-supplier-support-ticket-system>
  </ng-template>
</ng-template>
